import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "./config";
import { useUser } from "../contexts/user-context";

const portfolioUrl = 'portfolio/';

export function useUpdateEducations() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const profileId = user?.profile?.profile_id || user?.profile?.id;

  return useMutation({
    mutationFn: async (data) => {
      const items = Array.isArray(data) ? data : (data?.items || []);
      const deletedIds = Array.isArray(data) ? [] : (data?.deletedIds || []);
      const existing = items.filter((item) => item.id);
      const created = items.filter((item) => !item.id).map((item) => ({ ...item, profile: profileId }));
      const requests = [
        ...existing.map((item) => axiosInstance.patch(`${portfolioUrl}educations/${item.id}/`, item)),
        ...(created.length > 0 ? [axiosInstance.post(portfolioUrl + 'educations/', created)] : []),
        ...(deletedIds.length > 0 ? [axiosInstance.post(portfolioUrl + 'educations/bulk_delete/', { ids: deletedIds })] : []),
      ];
      return Promise.all(requests);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', profileId] });
    },
  });
}

export function useUpdateExperiences() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const profileId = user?.profile?.profile_id || user?.profile?.id;

  return useMutation({
    mutationFn: async (data) => {
      const items = Array.isArray(data) ? data : (data?.items || []);
      const deletedIds = Array.isArray(data) ? [] : (data?.deletedIds || []);
      const existing = items.filter((item) => item.id);
      const created = items.filter((item) => !item.id).map((item) => ({ ...item, profile: profileId }));
      const requests = [
        ...existing.map((item) => axiosInstance.patch(`${portfolioUrl}experiences/${item.id}/`, item)),
        ...(created.length > 0 ? [axiosInstance.post(portfolioUrl + 'experiences/', created)] : []),
        ...(deletedIds.length > 0 ? [axiosInstance.post(portfolioUrl + 'experiences/bulk_delete/', { ids: deletedIds })] : []),
      ];
      return Promise.all(requests);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', profileId] });
    },
  });
}

export function useUpdateSkills() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const profileId = user?.profile?.profile_id || user?.profile?.id;

  return useMutation({
    mutationFn: async (data) => {
      const payload = Array.isArray(data) ? data : { ...data, profile: profileId };
      return axiosInstance.post(portfolioUrl + 'skills/', payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', profileId] });
    },
  });
}

export function useUpdateProjects() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const profileId = user?.profile?.profile_id || user?.profile?.id;

  return useMutation({
    mutationFn: async (data) => {
      if (Array.isArray(data)) {
        const payload = data.map(item => ({ ...item, profile: profileId }));
        return axiosInstance.post('projects/bulk_create/', payload);
      }
      const payload = { ...data, profile: profileId };
      return axiosInstance.post('projects/', payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', profileId] });
    },
  });
}

export function useUpdateCertifications() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const profileId = user?.profile?.profile_id || user?.profile?.id;

  return useMutation({
    mutationFn: async (data) => {
      const payload = Array.isArray(data) ? data : { ...data, profile: profileId };
      return axiosInstance.post(portfolioUrl + 'certifications/', payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', profileId] });
    },
  });
}
